// src/components/Programs.js

import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axios';
import { AgGridReact } from 'ag-grid-react';
import Modal from 'react-modal';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './ProgramManager.css';
import ProgramDialog from './ProgramDialog';

const Programs = () => {
  const [programs, setPrograms] = useState([]);
  const [programModalIsOpen, setProgramModalIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState({ name: '', description: '' });
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPrograms();
  }, []);

  const fetchPrograms = async () => {
    try {
      const response = await axiosInstance.get('programs/');
      setPrograms(response.data);
    } catch (error) {
      setError('Error fetching programs');
    }
  };


  const openModal = (entity = null) => {
    if (entity == null) {
      entity = { name: '', description: '' };
    }
    setSelectedProgram(entity);
    setProgramModalIsOpen(true);
  };

  const programSaved = () => {
    closeModal();
    fetchPrograms();
  };

  const closeModal = () => {
    setProgramModalIsOpen(false);
    setSelectedProgram(null);
  };

  const openDeleteModal = (org) => {
    setSelectedProgram(org);
    setDeleteModalIsOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setSelectedProgram(null);
  };

  const handleDelete = async () => {
    try {
      await axiosInstance.delete(`programs/${selectedProgram.id}/`);
      fetchPrograms();
      closeDeleteModal();
    } catch (error) {
      setError('Error deleting organization');
    }
  };

  const renderEditButton = (params) => (
    <button className="icon-button" onClick={() => openModal(params.data)}>
      <EditIcon />
    </button>
  );

  const renderDeleteButton = (params) => (
    <button className="icon-button" onClick={() => openDeleteModal(params.data)}>
      <DeleteIcon />
    </button>
  );

  const onRowDoubleClicked = (params) => {
    openModal(params.data);
  };

  const columns = [
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          {renderEditButton(params)}
          {renderDeleteButton(params)}
        </>
      ),
      width: 100,
      cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'space-around' }
    },
    { headerName: "Name", field: "name", flex: 1 },
    { headerName: "Description", field: "description", flex: 2 },
  ];

  return (
    <div className="programs-container">
      <h1>Manage Programs</h1>
      <button onClick={() => openModal()} className="add-organization-button">Add Program</button>
      {error && <div className="error-message">{error}</div>}
      <div
        className="ag-theme-alpine"
        style={{
          height: '400px',
          width: '80%'
        }}
      >
        <AgGridReact
          rowData={programs}
          columnDefs={columns}
          domLayout="autoHeight"
          onRowDoubleClicked={onRowDoubleClicked}
          overlayNoRowsTemplate="."
        />
      </div>
      <ProgramDialog
          open={programModalIsOpen}
          onClose={closeModal}
          programData={selectedProgram}
          onSubmit={programSaved}
            />
      <Modal
        isOpen={deleteModalIsOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Confirm Delete</h2>
        <p>Are you sure you want to delete the organization "{selectedProgram && selectedProgram.name}"?</p>
        <button onClick={handleDelete}>Yes, Delete</button>
        <button onClick={closeDeleteModal}>Cancel</button>
      </Modal>
    </div>
  );
};

export default Programs;
